import { formatQueryRange } from '../utils/common';
import { cleanQueryParams } from '../utils/queryParams';
import { handleApiCalls } from './axiosInstance';

const RateQuotesAPI = Object.freeze({
  fetchRateQuotes: async (params = {}, pageNumber, pageSize) => {
    const range = formatQueryRange(pageNumber, pageSize);
    const queryParams = cleanQueryParams({ ...params, range });
    const result = await handleApiCalls(
      'get',
      `${process.env.REACT_APP_HOST_API}rate-quotes?${queryParams}`,
    );
    return result.data;
  },

  deleteRateQuote: async id => {
    const result = await handleApiCalls(
      'delete',
      `${process.env.REACT_APP_HOST_API}rate-quotes/${id}`,
    );
    return result.data;
  },

  createRateQuote: async data => {
    const result = await handleApiCalls(
      'post',
      `${process.env.REACT_APP_HOST_API}rate-quotes`,
      data,
    );
    return result.data;
  },
});

export default RateQuotesAPI;
